
import Contact from "../company/Contact";

export { Page }

function Page() {
  return <Contact />;
}
